import { render, staticRenderFns } from "./BaseCardExtraDetailsSolution.vue?vue&type=template&id=3e13d88c&scoped=true&"
import script from "./BaseCardExtraDetailsSolution.vue?vue&type=script&lang=ts&"
export * from "./BaseCardExtraDetailsSolution.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCardExtraDetailsSolution.vue?vue&type=style&index=0&id=3e13d88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e13d88c",
  null
  
)

export default component.exports